import classNames from 'classnames'
import { ParagraphSM, TitleXS } from '@/atoms/Text'

interface WhyAngelCardProps {
  icon: React.ReactNode
  title: string
  description: string
  wide?: boolean
}

export const WhyAngelCard: React.FC<WhyAngelCardProps> = ({ icon, title, description, wide }) => {
  return (
    <div
      className={classNames(
        'flex flex-col justify-center rounded-2xl bg-core-gray-900 px-6 py-[16px] w-full md:items-start md:px-8 md:py-6 lg:gap-4 lg:p-10 se:px-4 se:py-3',
        {
          'lg:flex-1': !wide,
          'lg:shrink-0 lg:min-w-[579px]  xl:basis-[60%]': wide,
        },
      )}
    >
      <div className="flex flex-row items-center gap-3 md:max-w-[257px] lg:max-w-[268px] lg:flex-col lg:items-start lg:gap-10 se:gap-2">
        {icon}
        <TitleXS className="se:photon-caption-md md:photon-title-md lg:photon-title-lg" color="white" weight="bold">
          {title}
        </TitleXS>
      </div>
      <ParagraphSM
        className="se:photon-caption-sm lg:photon-paragraph-md max-w-full"
        color="core-gray-500"
        weight="normal"
      >
        {description}
      </ParagraphSM>
    </div>
  )
}
